import * as React from 'react';
import { SpeedTest as SpeedTest$2 } from './SpeedTest.styles.js';

var SpeedTest = function SpeedTest(_ref) {
  var speedTestId = _ref.speedTestId,
    style = _ref.style,
    url = _ref.url;
  return /*#__PURE__*/React.createElement(SpeedTest$2, {
    className: "leshen-speed-test-module"
  }, /*#__PURE__*/React.createElement("div", {
    id: speedTestId,
    style: style
  }), /*#__PURE__*/React.createElement("script", {
    src: url
  }));
};
var SpeedTest$1 = SpeedTest;

export { SpeedTest$1 as default };
//# sourceMappingURL=index.js.map
